import RegisterSuccess from 'components/pages/RegisterSuccess/RegisterSuccess';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('account');
export default buildPage(RegisterSuccess, {
  requiresAuthentication: true,
  fullPageWidth: false,
  metaData: {
    title: 'Welcome to Mobiworkx',
    description: 'Registration Successful',
  },
});
